import SDIcon from '../SDIcon'
import type { SDIconProps } from '../SDIcon'

const IconStorefront = ({ size = 16, color = 'currentColor', ...props }: SDIconProps) => (
  <SDIcon viewBox='0 0 24 24' size={size} color={color} aria-hidden='true' {...props}>
    <g fill='none' stroke='currentColor' strokeWidth='1.9' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M4 9l1.5-5h13L20 9' />
      <path d='M4 9a2.67 2.67 0 0 0 5.33 0 2.67 2.67 0 0 0 5.34 0 2.67 2.67 0 0 0 5.33 0' />
      <path d='M5 11.5V20h14v-8.5' />
      <path d='M10 20v-5h4v5' />
    </g>
  </SDIcon>
)

export default IconStorefront
